import { useTranslation } from 'react-i18next';
import { Check, Loader2 } from 'lucide-react';
import type { AutosaveStatus } from '../autosave/useWizardAutosave';

/**
 * Quiet footer readout of the wizard's silent autosave (renders nothing while
 * idle). Failures stay muted here on purpose — Weiter is the loud path that
 * retries the residual delta authoritatively.
 */
export function AutosaveIndicator({ status }: { status: AutosaveStatus }) {
  const { t } = useTranslation();

  if (status === 'idle') return null;

  switch (status) {
    case 'pending':
      return (
        <span className="text-[13px] text-muted-foreground">
          {t('initialSetup.autosave.pending')}
        </span>
      );
    case 'saving':
      return (
        <span className="flex items-center gap-1.5 text-[13px] text-muted-foreground">
          <Loader2 className="size-3.5 animate-spin" />
          {t('initialSetup.autosave.saving')}
        </span>
      );
    case 'saved':
      return (
        <span className="flex items-center gap-1.5 text-[13px] text-muted-foreground">
          <Check className="size-3.5" />
          {t('initialSetup.autosave.saved')}
        </span>
      );
    case 'error':
      return <span className="text-[13px] text-warning">{t('initialSetup.autosave.error')}</span>;
    default:
      return status satisfies never;
  }
}
